import L from 'leaflet';
import 'leaflet-easybutton'; // This plugin extends L

function makeMarker(feature, latlng) {
  const zIndex = parseInt(feature.properties['z-index-offset']) || 0;
  const color = feature.properties["marker-color"];
  const icon = feature.properties["marker-symbol"];
  const html = `
  <svg class="cb-marker-svg" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <!--40x40 with the center tip of the marker at 16x40 -->
    <defs>
      <!-- Define the path once with an id -->
      <path id="marker" d="M 0,16 A 16,16 0 1,1 32,16 Q 28,26 16,40 Q 4,26 0,16 Z"/>
    </defs>
  
    <!-- Shadow version -->
    <use href="#marker"
         class="cb-marker-shadow"
         fill="#000000"
         opacity="0.2"
         transform="translate(16, 40) skewX(-30) scale(1, 0.5) translate(-16, -40)"/>
  
    <!-- Original marker -->
    <use href="#marker"
         class="cb-marker"
         fill="${color}"/>
  </svg>
  <div class="cb-marker-icon"
       style="position: absolute;
       top: 16px;
       left: 16px;
       transform: translate(-50%, -50%);
       color: white;
       font-size: 14px;"><i class="fas fa-${icon}"></i></div>
  `
  const marker = L.marker(latlng, {icon:L.divIcon({
      className: 'cb-leaflet-div-icon',
      html: html,
      iconSize: [40, 40],
      iconAnchor: [16,40]
    }), zIndexOffset:zIndex});

   marker.on('click', (e)=>e.target._map.flyTo(latlng, 12));
   return marker;
}

async function createLayer(map, geojsonurl) {
  const response = await fetch(geojsonurl);
  if(!response.ok) {
    console.log("Unable to load map data");
    return null;
  }

  const content = await response.json();
  const layer = L.geoJson(content, {
    pointToLayer: makeMarker,
    onEachFeature: function(feature, layer) {
      if(feature.properties.title !== undefined) {
        layer.bindTooltip(feature.properties.title);
      }
    }
  });
  return layer;
}

function markers(layer, cb) {
  if(layer instanceof L.Marker) {
    cb(layer);
  }
  if(!layer.eachLayer) {
    return;
  }
  layer.eachLayer(function(l){
    markers(l, cb);
  });
}
function getMapState(map) {
  const urlParams = new URLSearchParams(window.location.search);
  let lat = urlParams.get('lat');
  let lng = urlParams.get('lng');
  let zoom = urlParams.get('zoom');
  let view = null;
  if(lat != null && lng != null && zoom != null) {
    view = {lat:lat, long:long, zoom:zoom}
  }

  let feature = urlParams.get('feature');
  if(feature != null) {
    markers(map, m=>{
      if(m.feature.properties.title === feature) {
        view = {...m.getLatLng(), zoom:12}
      }
    });
  }
  
  return {
    view:view
  }
}

const positionIcon = L.divIcon({
    className: 'cb-location-tracker-icon',
    html: `<svg width="15" height="15" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 0 L30 30 L15 23 L0 30 Z"/>
</svg>`,
    iconSize: [15, 15],
    iconAnchor: [7.5, 7.5]
  });

function createPositionButton(map) {
  var positionMarker = L.marker([0,0], {icon:positionIcon});
  var latest = null;
  var updateMarkerPosition = (e) => {
    var radius = e.accuracy;
    //add to the map if not already on it now we have a location.
    positionMarker.addTo(map);
    positionMarker.setLatLng(e.latlng);
    latest = e.latlng;
  }
  map.on("locationfound", updateMarkerPosition);
  var updateViewPosition = (e) => {
     map.setView(e.latlng, 15)
  }
  const enableMarker = ()=> {
    if(latest != null) {
      map.setView(latest, 15);
    }
    map.on("locationfound", updateViewPosition);
  }
  const disableMarker = ()=> {
    map.off("locationfound", updateViewPosition);
  }


  var watchId = null
  var toggleButton = L.easyButton({
    states: [ {
      stateName: 'disable-follow',
      icon: 'fa-location-arrow cb-disabled',
      onClick: function(control) {
          enableMarker();
          control.state('enable-follow');
      }
    },
    {
      stateName: 'enable-follow',
      icon: 'fa-location-arrow cb-enabled',
      onClick: function(control) {
        disableMarker();
        control.state('disable-follow');
      }
   }]
  });

  return toggleButton;
}

function createFullscreenButton(map) {

  var toggleButton = L.easyButton({
    states: [ {
      stateName: 'disable-feature',
      icon: 'fa-up-right-and-down-left-from-center cb-disabled',
      onClick: function(control) {
          map.getContainer().requestFullscreen();
          control.state('enable-feature');
      }
    },
    {
      stateName: 'enable-feature',
      icon: 'fa-up-right-and-down-left-from-center cb-enabled',
      onClick: function(control) {
        document.exitFullscreen();
        control.state('disable-feature');
      }
   }]
  });
  return toggleButton;
}

export function displayLayers(id, metadata) {
  (async ()=> {
    const map = L.map(id);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; [OpenStreetMap](https://www.openstreetmap.org) contributors'
    }).addTo(map);
    
    const layersByTitle = await Promise.all(metadata.map( async (meta)=>{
      const layer = await createLayer(map, meta.url);
      return {
       title: meta.properties.title,
       layer: layer
      };
    }));

    const allLayersGroup = L.featureGroup(layersByTitle.map(({layer})=>layer));

    const control = L.control.layers({},{}).addTo(map);
    layersByTitle.forEach( ({title, layer})=>{
      control.addOverlay(layer, title);
      layer.addTo(map) 
    });

    createPositionButton(map).addTo(map);
    createFullscreenButton(map).addTo(map);

    const mapState = getMapState(map);
    setTimeout(() => {
      //this is a hack. There should be a better way to do this.
      map.invalidateSize();
      if(mapState.view) {
        map.setView([parseFloat(mapState.view.lat), parseFloat(mapState.view.lng)], parseInt(mapState.view.zoom));
      } else {
        map.fitBounds(allLayersGroup.getBounds());
      }
      map.on('locationerror', (e)=>console.log("error: " + e.message))
      map.locate({watch:true, enableHighAccurancy:true});
    }, 100);
  })();
}
